import React from "react";


const LandryCart = (props) => {
  const {
    clothCount,
    setClothCount,
    laundryObj,
    setLaundryObj,
    handleAddCoth,
    services,
    onChange,
  } = props;

  const deleteItem = (index) => {
    let remainingItems = laundryObj.filter((obj, i) => i !== index);
    setLaundryObj(remainingItems);
  };

  
  return (
    <>
      <div className="col-12">
        <p>Please select cloth type and Quantity</p>
        <div className="laundry_cart">
          <div>
            <select
              name="cloth_type"
              onChange={onChange}
              className="form-select form-select-lg shadow-none select-cloth"
              aria-label=".form-select-lg example"
            >
              <option value="">Select Cloth Type</option>
              {services?.["cloth-type"].map((item) => (
                <option value={item.name}>{item.name}</option>
              ))}
            </select>
            <div className="change_quantity select_amount">
              <span
                onClick={() => {
                  clothCount > 1 && setClothCount((prev) => prev - 1);
                }}
              >
                <i className="fa-solid fa-minus"></i>
              </span>
              <span>{clothCount}</span>
              <span
                onClick={() => {
                  setClothCount((prev) => prev + 1);
                }}
              >
                <i className="fa-solid fa-plus"></i>
              </span>
            </div>
          </div>

          <div className="addItem">
            <button type="button" onClick={handleAddCoth}>
              Add +
            </button>
          </div>
          {/* <p>{`You selected ${value}`}</p> */}
          <div className=" col-12 displayItem">
            {laundryObj?.map((item, index) => (
              <div key={index}>
                <span>
                  <span>{item.cloth_type}</span> <br />
                  <span>({item.service_type + " & " + item.extra})</span>
                </span>

                <span>{item.cloth_count}pcs</span>
                <span onClick={() => deleteItem(index)}>
                  <i className="fa-solid fa-xmark"></i>
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default LandryCart;
